module.exports = __webpack_public_path__ + "img/stripe.3cb4d333.png";